<template>
    <button class="button button-gray" id="lang-switcher" @click="changeLanguage">
        <i class="fas fa-globe"></i>&nbsp;
        {{ text }}
    </button>
</template>

<script>
import { checkCookie, setCookie } from '../common/utils';
import { COOKIE_LIFESPAN, USER_LANGUAGE_COOKIE, RUS, ENG } from "../common/const.js";

export default {
    data() {
        return {
            currentLang: null
        }
    },
    props: {
        text: {
            default: 'RU / EN'
        },
    },
    methods: {
        changeLanguage() {
            let newLang = this.currentLang == RUS ? ENG : RUS;
            setCookie(USER_LANGUAGE_COOKIE, newLang, COOKIE_LIFESPAN);
            window.location.reload();
        }
    },
    mounted() {
        this.currentLang = checkCookie(USER_LANGUAGE_COOKIE);
    }
}
</script>
<style scoped>
.button-gray:hover {
    color: black;
}
</style>
